import { Component, OnInit, TemplateRef, Input, ViewChild } from '@angular/core'
import { CpmService } from '../../service/cpm.service'
import { ActivatedRoute } from '@angular/router'
import { OverlayModule } from '@angular/cdk/overlay'
import { MatMenuTrigger } from '@angular/material/menu'

import { StoreService } from '../../service/store.service'
import { Subscription } from 'rxjs/Subscription'
@Component({
  selector: 'app-address-executive-summary',
  templateUrl: './address-executive-summary.component.html',
  styleUrls: ['./address-executive-summary.component.scss']
})
export class AddressExecutiveSummaryComponent implements OnInit {
  subscription: Subscription
  addressThai
  zipCode
  constructor(
    private cpmService: CpmService,
    private activatedRoute: ActivatedRoute,
    private store: StoreService
  ) {}

  ngOnInit() {
    this.addressThai = ''
    this.zipCode = ''
    this.subscription = this.store
      .getSecurityProfileNewResultObservable()
      .subscribe(response => {
        if (!response) {
          return
        }
        this.addressThai = response['addressThai']
        this.zipCode = response['zipCode']
      })
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/address-executive-summary/address-executive-summary.component.ts